module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hidden-xs"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    staticClass: "pull-left",
    attrs: {
      "src": require("../../../assets/img/brasao.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("FALE COM O PREFEITO")]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "color": "tomato"
    }
  }, [_vm._v(_vm._s(_vm.env))])]), _vm._v(" "), _c('span', {
    staticClass: "navbar-btn pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n\t\t\t\t\tINSTRUÇÕES\n\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/agendas",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n\t\t\t\t\tAGENDAS\n\t\t\t\t")]), _vm._v(" "), _c('v-logged-user')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "visible-xs text-center"
  }, [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/brasao.png"),
      "alt": "logo"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("FALE COM O PREFEITO")]), _vm._v(" "), _c('span', {
    staticClass: "title",
    staticStyle: {
      "font-size": "24px",
      "color": "tomato"
    }
  }, [_vm._v(_vm._s(_vm.env))])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-group-justified",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n\t\t\t\t\t\tINSTRUÇÕES\n\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn-warning",
    attrs: {
      "to": "/agendas",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v("\n\t\t\t\t\t\tAGENDAS\n\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('v-logged-user', {
    staticClass: "btn-block"
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7e4af99a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e4af99a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/header.vue
// module id = 380
// module chunks = 1